import React from 'react'
import { RenderSelect } from './renderHelpers'
import OptionsRow from '../components/OptionsRow'

export const formattedRows = ({
    data,
    rows,
    isMobile,
    isTablet,
    options,
    openOption,
    setOpenOption,
}) => {
    return data?.map((row, index) => {
        return {
            ...row,
            index,
            customId: index,
            options: rows?.find(r => r?.id === row?.id)?.options || (
                <OptionsRow
                    activeOption={openOption}
                    setActiveOption={setOpenOption}
                    rowData={row}
                    options={options}
                    isLast={
                        isMobile || isTablet
                            ? false
                            : index === data?.length - 1
                    }
                />
            ),
            select: rows?.find(r => r?.id === row?.id)?.select,
        }
    })
}

export const handleToggleSelect = ({
    customId,
    exists,
    singleSelection,
    selectedItems,
    onSelectItem,
    rows,
}) => {
    if (singleSelection) {
        const newSelection = rows.find(row => row?.customId === customId)
        onSelectItem(newSelection ? [newSelection] : [])
        return
    }

    if (exists) {
        onSelectItem(selectedItems.filter(item => item?.customId !== customId))
    } else {
        onSelectItem([
            ...selectedItems,
            rows.find(row => row?.customId === customId),
        ])
    }
}

export const sortByField = ({
    field,
    order,
    data,
    query,
    results,
    rows,
    setRows,
    setResults,
    cols,
    isMobile,
    isTablet,
    selectedItems,
    onSelectItem,
    isInCard,
    options,
    openOption,
    setOpenOption,
    getRows,
    singleSelection,
}) => {
    if (order === 'none') {
        const hasSelect = cols?.some(col => col?.field === 'select')
        const newFormattedRows = formattedRows({
            data,
            rows,
            isMobile,
            isTablet,
            options,
            openOption,
            setOpenOption,
        })

        setRows(
            hasSelect
                ? newFormattedRows.map(row => ({
                      ...row,
                      select: renderSelect(
                          row?.customId,
                          row?.salesforceID,
                          selectedItems,
                          onSelectItem,
                          isInCard,
                          isMobile,
                          isTablet,
                          getRows,
                          singleSelection,
                      ),
                  }))
                : newFormattedRows,
        )

        return
    }

    const dataToSort = query ? results : rows
    const newRows = [...dataToSort].sort((a, b) => {
        const fieldValue =
            typeof a[field] === 'string' || typeof a[field] === 'number'
                ? field
                : `${field}Key`

        if (a[fieldValue] === '-') return 1
        if (b[fieldValue] === '-') return -1

        const aValue = String(a[fieldValue]).toLowerCase()
        const bValue = String(b[fieldValue]).toLowerCase()

        return order === 'asc'
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue)
    })

    if (query) {
        setResults(newRows)
    } else {
        setRows(newRows)
    }
}

export const toggleSorting = ({
    columnField,
    cols,
    setCols,
    data,
    query,
    results,
    rows,
    setRows,
    setResults,
    isMobile,
    isTablet,
    selectedItems,
    onSelectItem,
    isInCard,
    options,
    openOption,
    setOpenOption,
    getRows,
    singleSelection,
}) => {
    const newCols = cols.map(col => ({
        ...col,
        sorting:
            col.field === columnField
                ? col.sorting === 'asc'
                    ? 'desc'
                    : col.sorting === 'desc'
                    ? 'none'
                    : 'asc'
                : 'none',
    }))

    setCols(newCols)

    sortByField({
        field: columnField,
        order: newCols.find(col => col.field === columnField)?.sorting,
        data,
        query,
        results,
        rows,
        setRows,
        setResults,
        cols: newCols,
        isMobile,
        isTablet,
        selectedItems,
        onSelectItem,
        isInCard,
        options,
        openOption,
        setOpenOption,
        getRows,
        singleSelection,
    })
}

export const getCellSize = ({ width, item, cols }) => {
    let size = width / cols?.length
    if (cols?.find(i => i.field === 'location') != null) {
        if (item?.field === 'location') {
            size += 100
        } else {
            size -= 10 / cols?.length
        }
    }
    if (cols?.find(i => i.field === 'statusC') != null) {
        if (item?.field === 'statusC') {
            size += 100
        } else {
            size -= 10 / cols?.length
        }
    }
    if (cols?.find(i => i.field === 'type') != null) {
        if (item?.field === 'type') {
            size = 160
        } else {
            size += (size - 160) / cols?.length
        }
    }
    if (cols?.find(i => i.field === 'options') != null) {
        if (item?.field === 'options') {
            size = 64
        } else {
            size += (size - 64) / cols?.length
        }
    }
    if (cols?.find(i => i.field === 'select') != null) {
        if (item?.field === 'select') {
            size = 32
        } else {
            size += (size - 32) / cols?.length
        }
    }
    return size
}

export const onSelectRow = ({
    customId,
    selectedItems,
    onSelectItem,
    rows,
    singleSelection,
}) => {
    const exists = selectedItems?.find(item => item?.customId === customId)
    handleToggleSelect({
        customId,
        exists,
        singleSelection,
        selectedItems,
        onSelectItem,
        rows,
    })
}

export const renderSelect = (
    customId,
    rowSalesforceID,
    selectedItems,
    onSelectItem,
    isInCard,
    isMobile,
    isTablet,
    getRows,
    singleSelection,
) => {
    const exists = selectedItems.find(
        item =>
            item?.customId === customId ||
            item?.salesforceID === rowSalesforceID,
    )
    return (
        <RenderSelect
            customId={customId}
            exists={exists}
            selectedItems={selectedItems}
            onSelectItem={onSelectItem}
            isInCard={isInCard}
            isMobile={isMobile}
            isTablet={isTablet}
            getRows={getRows}
            singleSelection={singleSelection}
        />
    )
}

export const itemSelected = (selectedItems, rowData) => {
    return selectedItems?.find(
        item =>
            item?.customId === rowData?.customId ||
            item?.salesforceID === rowData.salesforceID,
    )
}
